import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const WindowsBlinds = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 40 40"
    style={{ ...style(props.size, props.height), ...props.style }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-596.000000, -1153.000000)"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      >
        <g transform="translate(596.000000, 1153.000000)">
          <path d="M38.3333333,36.6666667 C39.25,36.6666667 40,37.4166667 40,38.3333333 C40,39.25 39.25,40 38.3333333,40 L38.3333333,40 L1.66666667,40 C0.75,40 0,39.25 0,38.3333333 C0,37.4166667 0.75,36.6666667 1.66666667,36.6666667 L1.66666667,36.6666667 Z M36.6666667,0 L36.6666667,33.3333333 L3.33333333,33.3333333 L3.33333333,0 L36.6666667,0 Z M18.3333333,18.3333333 L8.33333333,18.3333333 L8.33333333,28.3333333 L18.3333333,28.3333333 L18.3333333,18.3333333 Z M31.6666667,18.3333333 L21.6666667,18.3333333 L21.6666667,28.3333333 L31.6666667,28.3333333 L31.6666667,18.3333333 Z M18.333,15 L8.333,15 L8.33333333,16 L18.3333333,16 L18.333,15 Z M31.666,15 L21.666,15 L21.6666667,16 L31.6666667,16 L31.666,15 Z M18.333,13 L8.333,13 L8.333,14 L18.333,14 L18.333,13 Z M31.666,13 L21.666,13 L21.666,14 L31.666,14 L31.666,13 Z M18.333,11 L8.333,11 L8.333,12 L18.333,12 L18.333,11 Z M31.666,11 L21.666,11 L21.666,12 L31.666,12 L31.666,11 Z M18.333,9 L8.333,9 L8.333,10 L18.333,10 L18.333,9 Z M31.666,9 L21.666,9 L21.666,10 L31.666,10 L31.666,9 Z M18.333,7 L8.333,7 L8.333,8 L18.333,8 L18.333,7 Z M31.666,7 L21.666,7 L21.666,8 L31.666,8 L31.666,7 Z M18.3333333,5 L8.33333333,5 L8.333,6 L18.333,6 L18.3333333,5 Z M31.6666667,5 L21.6666667,5 L21.666,6 L31.666,6 L31.6666667,5 Z"></path>
        </g>
      </g>
    </g>
  </svg>
);
